import { RootState } from "@/app/stores";
import { getPartnerBonusTransactionsAggregates, getPartnerDailyStatistics, getPartnerMonthlyStatistics, getPartnerStatistics, IGetPartnerBonusTransactionsAggregatesResults, IPartnerDailyStatistics, IPartnerMonthlyStatistics, IPartnerStatisticsResults } from "@/shared/api/partners";
import { ErrorType } from "@/shared/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

export const fetchPartnerStatistics = createAsyncThunk<
    IPartnerStatisticsResults,
    void,
    { state: RootState }
>('partnerSales/fetchPartnerStatistics', async(_, thunkAPI) => {
    try {
        const { startDate, endDate, selectedPartners } = thunkAPI.getState().partnerStatistics
        const data = await getPartnerStatistics(startDate, endDate, selectedPartners)
        return data.data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchDiscountAggregates = createAsyncThunk<
    IGetPartnerBonusTransactionsAggregatesResults,
    void,
    { state: RootState }
>('partnerSales/fetchDiscountAggregates', async(_, thunkAPI) => {
    try {
        const { startDate, endDate, selectedPartners } = thunkAPI.getState().partnerStatistics
        const data = await getPartnerBonusTransactionsAggregates(startDate, endDate, selectedPartners)
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchDailyStatistics = createAsyncThunk<
    IPartnerDailyStatistics[],
    void,
    { state: RootState }
>('partnerSales/fetchDailyStatistics', async(_, thunkAPI) => {
    try {
        const { startDate, endDate, selectedPartners } = thunkAPI.getState().partnerStatistics
        const data = await getPartnerDailyStatistics(startDate, endDate, selectedPartners)
        return data.data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchMonthlyStatistics = createAsyncThunk<
    IPartnerMonthlyStatistics[],
    void,
    { state: RootState }
>('partnerSales/fetchMonthlyStatistics', async(_, thunkAPI) => {
    try {
        const { startDate, selectedPartners } = thunkAPI.getState().partnerStatistics
        const data = await getPartnerMonthlyStatistics(startDate, selectedPartners)
        return data.data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})